declare let window: any;

export class DynamicEnvironment {
   
    public get envName(): string {
        return window.config.envName || 'sit01-int';
    }
    
    public get environment(): string {
        return window.config.environment || window.config.domain;
    }

    public get camUrl(): string {
        return window.config.camUrl;
    }

    public get webAppService(): string {
        return window.config.webAppService;
    }

    public get jfkURL(): string {
        return window.config.jfkURL;
    }

    public get domain(): string {
        return window.config.domain;
    }

    public get production(): boolean {
        return window.config.production;
    }

    public get launchDarklyClientId(): string {
        // Per-environment client-side ID sourced from runtime config
        // (src/assets/app-config/*.json). Non-secret and safe to ship to the browser.
        return window.config.launchDarklyClientId || '';
    }
}
